import { useNavigate } from 'react-router-dom'
import { GetHcsAnnContactByIdResponseIds } from '@toktokdoctech/tokapi-client'
import { useAppDispatch } from '../../../../store'
import { displaySnackbar } from '../../../../actions/main'
import { UseContactServicesProps } from './_props'
import useCurrentHcs from '../../../../hooks/useCurrentHcs'
import useAnnContactUtils from '../../../../hooks/useAnnContactUtils'

const useContactServices = ({ data }: UseContactServicesProps) => {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const healthCareService = useCurrentHcs()

    const { addAnnContact, deleteAnnContact, isAddingContact, isDeletingContact } = useAnnContactUtils()

    const handleCreateContact = async (submitValues: GetHcsAnnContactByIdResponseIds) => {
        const rpps = Number(submitValues.rppsNum)

        try {
            await addAnnContact({ hcsId: healthCareService.id, rpps })
        } catch (error) {
            console.error({ error })
            if (error instanceof Error) {
                dispatch(
                    displaySnackbar(
                        'error',
                        'Une erreur est survenue lors de la création du contact',
                        undefined,
                        `[ContactForm] erreur création contact ${error.message}`,
                    ),
                )
            } else {
                dispatch(
                    displaySnackbar(
                        'error',
                        'Une erreur est survenue lors de la création du contact',
                        undefined,
                        `[ContactForm] erreur innatendue lors de la création contact`,
                    ),
                )
            }
        }
    }

    const handleDeleteContact = async () => {
        try {
            if (!data) {
                return
            }

            try {
                await deleteAnnContact({ hcsId: healthCareService.id, contactId: data.id })
                dispatch(
                    displaySnackbar(
                        'success',
                        'Correspondant supprimé avec succès !',
                        undefined,
                        `[ContactForm] suppression correspondant ${data?.id ?? ''}`,
                    ),
                )
            } catch (err) {
                dispatch(
                    displaySnackbar(
                        'error',
                        'Il n’est pas possible de supprimer ce correspondant, car il est associé à votre établissement ou défini en tant que médecin traitant d’un patient',
                        undefined,
                        `[ContactForm] suppression correspondant ${data?.id ?? ''} impossible`,
                    ),
                )
            }

            navigate('/contacts')
        } catch (error) {
            console.error({ error })
            if (error instanceof Error) {
                dispatch(
                    displaySnackbar(
                        'error',
                        'Une erreur est survenue lors de la suppression du correspondant',
                        undefined,
                        `[ContactForm] suppression correspondant ${data?.id ?? ''} error: ${error.message}`,
                    ),
                )
            } else {
                dispatch(
                    displaySnackbar(
                        'error',
                        'Une erreur est survenue lors de la suppression du correspondant',
                        undefined,
                        `[ContactForm] erreur innatendue lors de la suppression correspondant`,
                    ),
                )
            }
        }
    }

    return {
        handleCreateContact,
        handleDeleteContact,
        isAddingContact,
        isDeletingContact,
    }
}

export default useContactServices
